interface Props {
  data: { month: string; used: number; charged: number }[];
}

export default function CreditTrend({ data }: Props) {
  const maxVal = data.length > 0 ? Math.max(...data.map((d) => Math.max(d.used, d.charged))) : 1;

  return (
    <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-6 h-full flex flex-col">
      <div className="mb-5">
        <h3 className="text-white font-semibold text-base">크레딧 사용 추이</h3>
        <p className="text-gray-500 text-xs mt-0.5">월별 충전 및 소비 현황</p>
      </div>
      {data.length === 0 ? (
        <div className="flex-1 flex items-center justify-center">
          <p className="text-gray-600 text-sm">크레딧 데이터가 없습니다</p>
        </div>
      ) : (
        <div className="flex items-end gap-3 h-40 px-2">
          {data.map((d) => {
            const usedH = maxVal > 0 ? (d.used / maxVal) * 100 : 0;
            const chargedH = maxVal > 0 ? (d.charged / maxVal) * 100 : 0;
            return (
              <div key={d.month} className="flex-1 flex flex-col items-center gap-1.5 group">
                <div className="relative w-full flex items-end justify-center h-28 gap-1">
                  <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-[#1a1a2e] border border-white/[0.1] rounded-lg px-2 py-1 text-xs text-white whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                    <p>사용 {d.used.toLocaleString()}</p>
                    <p>충전 {d.charged.toLocaleString()}</p>
                  </div>
                  <div
                    className="w-full max-w-[12px] bg-rose-500/70 rounded-t-sm transition-all duration-500"
                    style={{ height: `${usedH}%` }}
                  />
                  <div
                    className="w-full max-w-[12px] bg-emerald-500/70 rounded-t-sm transition-all duration-500"
                    style={{ height: `${chargedH}%` }}
                  />
                </div>
                <span className="text-gray-500 text-[10px]">{d.month}</span>
              </div>
            );
          })}
        </div>
      )}
      <div className="flex items-center gap-4 mt-4 pt-3 border-t border-white/[0.06]">
        <div className="flex items-center gap-1.5">
          <div className="w-2.5 h-2.5 rounded-sm bg-rose-500/70" />
          <span className="text-gray-400 text-xs">사용</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-2.5 h-2.5 rounded-sm bg-emerald-500/70" />
          <span className="text-gray-400 text-xs">충전</span>
        </div>
      </div>
    </div>
  );
}